// Vendor
import { createAction, props } from '@ngrx/store';
export const setFundChartSecurityGroup = createAction('[Fund Chart] Set security group', props());
